import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import IconButton from "@/components/Atoms/Button/IconButton";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const StyledComments = styled(FlexDiv)`
  flex-direction: column;
  gap: 32px;
`;

export const Name = styled(Typography)`
  color: ${theme.colorsV2.blueGray.shade_400};
`;

export const RecentFilter = styled(IconButton)`
  color: ${theme.colorsV2.blueGray.shade_400};
  padding: 0;
`;

export const RecentFilterText = styled(Typography)`
  color: ${theme.colorsV2.shyft.purple_text};
`;
